var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFireshipImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 191,
    viewBox: "0 0 209 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.665 122.988L48.3402 96.6587L108.53 70.0107L168.855 96.3401L108.665 122.988Z",
    fill: "url(#paint0_linear_4_22639)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.848 190.438L48.5236 164.109L108.704 137.461L169.029 163.79L108.848 190.438Z",
    fill: "url(#paint1_linear_4_22639)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_22639",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 96,
    width: 98,
    height: 59
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.517 96.3497L152.837 154.608L57.1841 151.857L62.5813 96.6201L108.607 116.683L154.517 96.3497Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_22639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.8033 81.6838C76.8033 81.6838 118.407 81.2396 146.339 74.23V124.407C146.339 124.407 112.855 138.311 76.8033 131.523V81.6838Z",
    fill: "#DEAD0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8033 81.6838L71.3481 74.23V125.402L76.8033 131.523V81.6838Z",
    fill: "#DEAD0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8033 81.6838L71.3481 74.23V125.402L76.8033 131.523V81.6838Z",
    fill: "url(#paint2_linear_4_22639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.329 74.23C135.709 76.8948 123.099 78.7293 111.562 79.8396V132.74C131.789 130.558 146.329 124.523 146.329 124.523V74.23Z",
    fill: "url(#paint3_linear_4_22639)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M76.8032 131.012L79.246 83.6824C79.246 83.6824 95.4762 84.4934 116.264 81.9444C137.051 79.3955 146.329 74.23 146.329 74.23C146.329 74.23 126.681 78.4976 111.561 79.8396C96.1037 81.2107 76.7936 81.6838 76.7936 81.6838V131.012H76.8032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.3481 110.688L76.8033 122.583V131.523L71.3481 125.402V110.688Z",
    fill: "#1C2538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8033 81.6451V131.485C89.0943 133.802 101.096 133.705 111.571 132.576V86.8588C83.1757 89.4078 76.8033 81.6451 76.8033 81.6451Z",
    fill: "url(#paint4_linear_4_22639)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M142.062 118.412C120.512 131.649 76.8033 128.298 76.8033 128.298V131.514C112.846 138.301 146.339 124.398 146.339 124.398V74.2204L142.072 118.412H142.062Z",
    fill: "#1C2538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.337 115.689L110.905 106.13C110.905 106.13 107.613 104.923 108.115 101.187C108.665 96.9966 115.037 94.7277 118.175 97.5663C121.072 100.192 119.537 103.977 116.901 105.435L119.411 114.627C119.527 115.061 119.237 115.496 118.793 115.544L109.129 116.616C108.617 116.674 108.211 116.201 108.346 115.708L108.337 115.689Z",
    fill: "#DEAD0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.447 112.223L114.236 104.132C116.573 102.838 117.944 99.4684 115.366 97.1222C114.96 96.7553 114.497 96.485 114.004 96.3015C111.243 96.5525 108.462 98.4546 108.105 101.148C107.613 104.885 110.895 106.092 110.895 106.092L108.8 113.903L115.829 113.13C116.273 113.082 116.573 112.648 116.447 112.213V112.223Z",
    fill: "#1C2538"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M108.337 115.689L110.905 106.13C110.905 106.13 107.613 104.923 108.115 101.187C108.665 96.9966 115.037 94.7277 118.175 97.5663C121.072 100.192 119.537 103.977 116.901 105.435L119.411 114.627C119.527 115.061 119.237 115.496 118.793 115.544L109.129 116.616C108.617 116.674 108.211 116.201 108.346 115.708L108.337 115.689Z",
    fill: "#1C2538"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M48.5237 164.109L48.3402 96.6587L108.665 122.988L108.849 190.438L48.5237 164.109Z",
    fill: "url(#paint5_linear_4_22639)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M169.038 96.3401L169.212 163.79L109.032 190.438L108.849 122.988L169.038 96.3401Z",
    fill: "url(#paint6_linear_4_22639)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.032 122.988L48.6974 96.678L108.877 70.0107L169.212 96.3208L109.032 122.988ZM154.922 96.369L108.897 76.2961L62.9869 96.6394L109.013 116.712L154.922 96.369Z",
    fill: "url(#paint7_linear_4_22639)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M62.5911 96.6298L37.5168 2.89832H177.834L154.527 96.3594L108.617 116.693L62.5911 96.6298Z",
    fill: "url(#paint8_linear_4_22639)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4_22639",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 0,
    width: 93,
    height: 117
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.517 96.3498V4.46242L74.0708 0.561768L62.5813 96.6201L108.607 116.683L154.517 96.3498Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4_22639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.246 83.6824C79.246 83.6824 95.4762 84.4934 116.264 81.9444C137.051 79.3955 146.329 74.23 146.329 74.23L138.876 67.8867L71.3481 74.23L76.8033 81.6838L79.246 83.6824Z",
    fill: "#DEAD0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.246 83.6824C79.246 83.6824 95.4762 84.4934 116.264 81.9444C137.051 79.3955 146.329 74.23 146.329 74.23L138.876 67.8867L71.3481 74.23L76.8033 81.6838L79.246 83.6824Z",
    fill: "url(#paint9_linear_4_22639)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M146.233 74.2203L146.329 74.201L138.316 70.31L127.743 71.4203L133.285 76.7403C140.208 75.5044 145.48 74.3844 146.233 74.2203Z",
    fill: "#1C2538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8033 81.6838C76.8033 81.6838 118.407 81.2396 146.339 74.23V124.407C146.339 124.407 112.855 138.311 76.8033 131.523V81.6838Z",
    fill: "#DEAD0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8033 81.6838L71.3481 74.23V125.402L76.8033 131.523V81.6838Z",
    fill: "#DEAD0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8033 81.6838L71.3481 74.23V125.402L76.8033 131.523V81.6838Z",
    fill: "url(#paint10_linear_4_22639)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M99.0582 80.7955L89.3163 75.8521L78.8019 76.7596L83.5908 81.5292C87.6845 81.3748 93.2169 81.143 99.0486 80.7955H99.0582Z",
    fill: "#1C2538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.329 74.23C135.709 76.8948 123.099 78.7293 111.562 79.8396V132.74C131.789 130.558 146.329 124.523 146.329 124.523V74.23Z",
    fill: "url(#paint11_linear_4_22639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3741 75.7845C89.3741 75.7845 84.0445 79.3279 78.8018 76.6728V62.8757C78.8018 53.2399 78.657 28.6388 96.0071 20.1809C111.977 12.3989 125.919 18.7327 130.476 24.1878C135.033 29.6429 137.485 31.8636 137.485 56.455C137.485 56.455 134.367 60.906 126.913 57.5654V42.2138C126.913 31.5353 118.03 23.9657 106.454 27.1905C94.8775 30.4153 89.6251 46.3075 89.6251 55.9916C89.6251 65.6756 89.3644 75.7845 89.3644 75.7845H89.3741Z",
    fill: "#727C92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0045 76.1899V65.5597C86.0045 56.6577 88.9397 25.9063 106.145 23.8884C123.36 21.8705 128.554 33.2152 128.554 42.9572V57.2467C131.683 58.1156 134.531 57.1984 134.531 57.1984V45.7475C134.531 20.345 115.704 13.8471 99.8499 19.3988C80.3466 26.2346 80.1825 51.1833 80.1825 61.7266V76.0934C80.1825 76.0934 81.177 76.663 83.2528 76.663C85.068 76.663 85.9948 76.1899 85.9948 76.1899H86.0045Z",
    fill: "#D4D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4376 77.5321V62.9915C81.4376 49.8992 80.5976 35.3684 91.6334 26.2829C99.0195 20.2002 111.793 14.0693 122.8 22.8554C122.8 22.8554 116.592 19.5437 104.89 21.523C93.1879 23.5023 83.8128 50.4206 83.8128 62.5474V77.6286C83.8128 77.6286 83.0404 77.6962 82.4225 77.6479C81.8045 77.5997 81.4473 77.5417 81.4473 77.5417L81.4376 77.5321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M89.374 75.7845C89.374 75.7845 89.5961 73.3417 89.5961 63.6577C89.5961 53.9737 90.1851 31.8153 106.464 27.1905C115.646 24.5836 123.147 28.8705 125.851 36.0732C124.837 31.4773 118.6 23.425 105.595 26.2153C92.5988 29.0056 89.6927 42.8414 88.5823 47.1089C87.4817 51.3668 87.9644 71.6714 87.8003 74.23C87.6361 76.7886 81.901 77.5996 78.8114 75.35V76.6727C84.0445 79.3279 89.3837 75.7845 89.3837 75.7845H89.374Z",
    fill: "#1C2538"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M136.578 54.9585C136.414 55.7889 135.776 57.6233 131.625 57.6233C127.473 57.6233 126.913 56.2716 126.913 56.2716V57.5654C134.367 60.906 137.485 56.4551 137.485 56.4551C137.485 43.9131 136.848 37.1932 135.622 32.887C136.684 38.738 136.742 54.1282 136.587 54.9489L136.578 54.9585Z",
    fill: "#1C2538"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M76.8033 81.6838C76.8033 81.6838 83.2819 89.292 112.102 86.8203C140.923 84.3486 146.339 74.23 146.339 74.23C146.339 74.23 127.029 78.43 111.571 79.8396C95.9687 81.2589 76.8033 81.6838 76.8033 81.6838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M76.8032 131.012L79.246 83.6824C79.246 83.6824 95.4762 84.4934 116.264 81.9444C137.051 79.3955 146.329 74.23 146.329 74.23C146.329 74.23 126.681 78.4976 111.561 79.8396C96.1037 81.2107 76.7936 81.6838 76.7936 81.6838V131.012H76.8032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.3481 110.688L76.8033 122.583V131.523L71.3481 125.402V110.688Z",
    fill: "#1C2538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8033 81.6451V131.485C89.0943 133.802 101.096 133.705 111.571 132.576V86.8588C83.1757 89.4078 76.8033 81.6451 76.8033 81.6451Z",
    fill: "url(#paint12_linear_4_22639)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M142.062 118.412C120.512 131.649 76.8033 128.298 76.8033 128.298V131.514C112.846 138.301 146.339 124.398 146.339 124.398V74.2204L142.072 118.412H142.062Z",
    fill: "#1C2538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.337 115.689L110.905 106.13C110.905 106.13 107.613 104.923 108.115 101.187C108.665 96.9966 115.037 94.7277 118.175 97.5663C121.072 100.192 119.537 103.977 116.901 105.435L119.411 114.627C119.527 115.061 119.237 115.496 118.793 115.544L109.129 116.616C108.617 116.674 108.211 116.201 108.346 115.708L108.337 115.689Z",
    fill: "#DEAD0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.447 112.223L114.236 104.132C116.573 102.838 117.944 99.4684 115.366 97.1222C114.96 96.7553 114.497 96.485 114.004 96.3015C111.243 96.5525 108.462 98.4546 108.105 101.148C107.613 104.885 110.895 106.092 110.895 106.092L108.8 113.903L115.829 113.13C116.273 113.082 116.573 112.648 116.447 112.213V112.223Z",
    fill: "#1C2538"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M108.337 115.689L110.905 106.13C110.905 106.13 107.613 104.923 108.115 101.187C108.665 96.9966 115.037 94.7277 118.175 97.5663C121.072 100.192 119.537 103.977 116.901 105.435L119.411 114.627C119.527 115.061 119.237 115.496 118.793 115.544L109.129 116.616C108.617 116.674 108.211 116.201 108.346 115.708L108.337 115.689Z",
    fill: "#1C2538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.716 72.521C135.936 72.521 138.547 71.7991 138.547 70.9086C138.547 70.0181 135.936 69.2962 132.716 69.2962C129.495 69.2962 126.884 70.0181 126.884 70.9086C126.884 71.7991 129.495 72.521 132.716 72.521Z",
    fill: "#1C2538"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M201.03 48.9555L203.07 55.1467L208.263 57.4277C208.726 57.5363 209.005 58.0794 209.005 58.6225C209.005 59.057 208.726 59.6001 208.263 59.7087L203.07 62.0983L201.03 68.1809C200.938 68.724 200.474 69.0499 200.103 69.0499C199.64 69.0499 199.176 68.724 199.083 68.1809L197.136 62.0983L191.851 59.7087C191.48 59.6001 191.202 59.057 191.202 58.6225C191.202 58.0794 191.48 57.5363 191.851 57.4277L197.136 55.1467L199.083 48.9555C199.176 48.4124 199.64 48.1951 200.103 48.1951C200.474 48.1951 200.938 48.4124 201.03 48.9555Z",
    fill: "#A3EA2A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74916 48.9032L5.73581 51.8978L8.2473 53.001C8.47154 53.0536 8.60608 53.3163 8.60608 53.5789C8.60608 53.7891 8.47154 54.0518 8.2473 54.1043L5.73581 55.2601L4.74916 58.2022C4.70431 58.4649 4.48007 58.6225 4.30068 58.6225C4.07644 58.6225 3.8522 58.4649 3.80735 58.2022L2.86554 55.2601L0.309212 54.1043C0.129821 54.0518 -0.00472279 53.7891 -0.00472278 53.5789C-0.00472277 53.3163 0.129821 53.0536 0.309213 53.001L2.86554 51.8978L3.80735 48.9032C3.8522 48.6405 4.07644 48.5354 4.30068 48.5354C4.48007 48.5354 4.70431 48.6405 4.74916 48.9032Z",
    fill: "#A3EA2A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6561 117.051L25.6428 120.046L28.1543 121.149C28.3785 121.202 28.5131 121.464 28.5131 121.727C28.5131 121.937 28.3785 122.2 28.1543 122.252L25.6428 123.408L24.6561 126.35C24.6113 126.613 24.3871 126.77 24.2077 126.77C23.9834 126.77 23.7592 126.613 23.7143 126.35L22.7725 123.408L20.2162 122.252C20.0368 122.2 19.9023 121.937 19.9023 121.727C19.9023 121.464 20.0368 121.202 20.2162 121.149L22.7725 120.046L23.7143 117.051C23.7592 116.788 23.9834 116.683 24.2077 116.683C24.3871 116.683 24.6113 116.788 24.6561 117.051Z",
    fill: "#A3EA2A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M191.651 127.742L192.637 130.736L195.149 131.84C195.373 131.892 195.507 132.155 195.507 132.417C195.507 132.628 195.373 132.89 195.149 132.943L192.637 134.099L191.651 137.041C191.606 137.303 191.381 137.461 191.202 137.461C190.978 137.461 190.754 137.303 190.709 137.041L189.767 134.099L187.211 132.943C187.031 132.89 186.897 132.628 186.897 132.417C186.897 132.155 187.031 131.892 187.211 131.84L189.767 130.736L190.709 127.742C190.754 127.479 190.978 127.374 191.202 127.374C191.381 127.374 191.606 127.479 191.651 127.742Z",
    fill: "#A3EA2A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_22639",
    x1: 48.3305,
    y1: 96.6704,
    x2: 168.845,
    y2: 96.3549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#719CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_22639",
    x1: 108.678,
    y1: 131.184,
    x2: 108.878,
    y2: 207.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#719CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3D5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_22639",
    x1: 71.3481,
    y1: 102.877,
    x2: 76.8033,
    y2: 102.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEAD0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1123",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_22639",
    x1: 111.562,
    y1: 103.485,
    x2: -38.9901,
    y2: 103.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEAD0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1123",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_22639",
    x1: 76.8033,
    y1: 107.492,
    x2: 111.562,
    y2: 107.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEAD0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4_22639",
    x1: 78.4346,
    y1: 85.44,
    x2: 78.7889,
    y2: 220.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#719CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3D5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4_22639",
    x1: 138.875,
    y1: 85.2822,
    x2: 139.229,
    y2: 220.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#719CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3D5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4_22639",
    x1: 108.881,
    y1: 68.4826,
    x2: 109.044,
    y2: 123.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D3D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#719CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4_22639",
    x1: 107.68,
    y1: 4.72312,
    x2: 107.68,
    y2: 115.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151C2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEAD0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4_22639",
    x1: 71.3481,
    y1: 75.8424,
    x2: 146.329,
    y2: 75.8424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEAD0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1123",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4_22639",
    x1: 71.3481,
    y1: 102.877,
    x2: 76.8033,
    y2: 102.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEAD0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1123",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4_22639",
    x1: 111.562,
    y1: 103.485,
    x2: -38.9901,
    y2: 103.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEAD0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1123",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4_22639",
    x1: 76.8033,
    y1: 107.492,
    x2: 111.562,
    y2: 107.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEAD0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireshipImage);
export default __webpack_public_path__ + "static/media/fireship-image.90e0a1bfe0e2d82ff0a71b4b6aab282e.svg";
export { ForwardRef as ReactComponent };